import React, { useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { translations } from '../i18n'
import { getPosts } from '../actions/blogActions'
import { toggleReadLater } from '../actions/blogActions'
import Loader from '../components/Loader'

function ReadLaterScreen() {
  const dispatch = useDispatch()
  const { lang } = useSelector(s => s.rootReducer.langRed)
  const T = translations[lang]
  const { loading, posts = [] } = useSelector(s => s.rootReducer.postsRed)
  const { ids: savedIds = [] } = useSelector(s => s.rootReducer.readLaterRed)

  useEffect(() => { dispatch(getPosts()) }, [dispatch])

  const savedPosts = posts.filter(p => savedIds.includes(p.id))
  const title   = (p) => p[`title_${lang}`]   || p.title_en
  const excerpt = (p) => p[`excerpt_${lang}`] || p.excerpt_en

  if (loading) return <div className='fc-section'><Container><Loader /></Container></div>

  return (
    <div>
      <div style={{ background: 'var(--navy)', color: '#fff', padding: '48px 0 36px' }}>
        <Container>
          <Link to='/blog/' style={{ color: 'var(--teal)', fontSize: '.88rem' }}>← Blog</Link>
          <h1 style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, marginTop: '.75rem' }}>{T.blog.stored_title}</h1>
        </Container>
      </div>
      <div className='fc-section'>
        <Container>
          {savedPosts.length === 0
            ? <p style={{ color: 'var(--muted)' }}>{T.blog.no_stored}</p>
            : (
              <Row className='g-4'>
                {savedPosts.map(post => (
                  <Col md={6} lg={4} key={post.id}>
                    <div className='blog-card'>
                      {post.image
                        ? <img src={post.image} alt={title(post)} className='blog-card-img' />
                        : <div className='blog-card-img-placeholder'>✍️</div>
                      }
                      <div className='blog-card-body'>
                        <div className='blog-card-title'>{title(post)}</div>
                        <div className='blog-card-excerpt'>{excerpt(post)}</div>
                      </div>
                      <div className='blog-card-footer'>
                        <Link to={`/blog/${post.slug}/`} style={{ color: 'var(--teal)', fontSize: '.85rem', fontWeight: 500 }}>{T.blog.read_more} →</Link>
                        <button className='btn-read-later saved' onClick={() => dispatch(toggleReadLater(post.id))}>{T.blog.remove}</button>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            )
          }
        </Container>
      </div>
    </div>
  )
}

export default ReadLaterScreen
